import { render, staticRenderFns } from "./ResetPasswordEmployer.vue?vue&type=template&id=618f3e0c&scoped=true"
import script from "./ResetPasswordEmployer.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmployer.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordEmployer.vue?vue&type=style&index=0&id=618f3e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f3e0c",
  null
  
)

export default component.exports